import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLayerGroup,
  faListOl,
  faMessage,
  faNetworkWired,
  faObjectGroup,
  faPersonCirclePlus,
  faPersonWalkingLuggage,
} from "@fortawesome/free-solid-svg-icons";
import "../DemRepres.css";
// Actions
import { saveVariableGlo } from "../actions/chariotActions";
import { listeClients, logout } from "../actions/clientsActions";
import { listeSocietes } from "../actions/societeActions";

const DemRepres = () => {
  // Redux state
  const { varGlo } = useSelector((state) => state.chariot);
  const { client } = useSelector((state) => state.client);
  const { clients } = useSelector((state) => state.clientsListeState);
  const { societes } = useSelector((state) => state.listeSocietes);

  // Local state
  const [tabRep, setTabRep] = useState([]);
  const [loading, setLoading] = useState(true);

  // Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { langue, societe } = location.state || {};

  // Load client data
  useEffect(() => {
    const loadData = async () => {
      if (!client) {
        navigate("/");
        return;
      }

      try {
        await dispatch(listeClients());
        await dispatch(listeSocietes());

        // Filter clients for the current representative
        const filteredClients = clients.filter(
          (cli) => cli?.cod_rep === client?.cod_cli
        );
        setTabRep(filteredClients);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [client, dispatch, navigate]);

  const handleNavigation = (path, state = {}) => {
    navigate(path, { state: { ...state, langue } });
    setTabRep([]);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    setTabRep([]);
  };

  if (loading) {
    return <div className="loading-spinner-repres">Loading...</div>;
  }

  return (
    <div className="app-container-repres">
      <div className="background-overlay-repres">
        <div className="content-container-repres">
          {/* Header Section */}
          <header className="app-header-repres">
            <h1 className="company-name-repres">
              {societes[0]?.nom_soc || societe}
            </h1>
            <h2 className="app-title-repres">منصة الطلبيات</h2>
          </header>

          {/* Main Content */}
          <main className="main-content-repres">
            {langue === "F" ? (
              <FrenchView
                varGlo={varGlo}
                client={client}
                societe={societe}
                onNavigate={handleNavigation}
                onLogout={handleLogout}
              />
            ) : langue === "A" ? (
              <ArabicView
                tabRep={tabRep}
                varGlo={varGlo}
                societe={societe}
                onSelectClient={(client) => dispatch(saveVariableGlo(client))}
                onNavigate={handleNavigation}
              />
            ) : (
              <EnglishView onNavigate={handleNavigation} />
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

// Component for French language view
const FrenchView = ({ varGlo, client, societe, onNavigate, onLogout }) => (
  <div className="view-container-repres">
    <div className="button-grid-repres">
      <ActionButton
        icon={faPersonWalkingLuggage}
        text="Saisie Commande Client"
        onClick={() => onNavigate("/RechClient")}
      />
      <ActionButton
        icon={faLayerGroup}
        text="Gamme Article"
        onClick={() => onNavigate("/marque-liste", { wcli: varGlo })}
      />
      <ActionButton
        icon={faObjectGroup}
        text="Famille Article"
        onClick={() => onNavigate("/ListeFamille", { wcli: varGlo })}
      />
      <ActionButton
        icon={faListOl}
        text="Mes Commandes"
        onClick={() => onNavigate("/RepresDetail", { code: client.cod_cli })}
      />
      <ActionButton
        icon={faListOl}
        text="Etat Presence Client"
        onClick={() =>
          onNavigate("/EtatPresenceClient", { code: client.cod_cli })
        }
      />
      <ActionButton
        icon={faListOl}
        text="Commande Par Client Finale"
        onClick={() =>
          onNavigate("/CommandeParClientFinale", { code: client.cod_cli })
        }
      />
      <ActionButton
        icon={faPersonCirclePlus}
        text="Demande Creation Client"
        onClick={() => onNavigate("/AjoutClient", { societe })}
      />
      <ActionButton
        icon={faNetworkWired}
        text="Déconnexion"
        onClick={onLogout}
      />
    </div>
  </div>
);

// Component for Arabic language view
const ArabicView = ({
  tabRep,
  varGlo,
  societe,
  onSelectClient,
  onNavigate,
}) => (
  <div className="view-container">
    <div className="dropdown-section">
      <Select
        options={tabRep.map((item) => ({
          value: item,
          label: `${item.nom_cli}:${item.cod_cli}`,
        }))}
        placeholder="اختار حريف"
        onChange={(selected) => onSelectClient(selected.value)}
        className="arabic-select"
      />
      <h3 className="dropdown-title">قائمة الحرفاء</h3>
    </div>

    <div className="button-grid arabic">
      <ActionButton
        icon={faObjectGroup}
        text="قــائــمة الــــحرفـــاء"
        onClick={() => onNavigate("/famille-liste", { wcli: varGlo })}
        arabic
      />
      <ActionButton
        icon={faLayerGroup}
        text="قــــائـــمة مــــاركــات البـضاعـــة"
        onClick={() => onNavigate("/marque-liste", { wcli: varGlo })}
        arabic
      />
      <ActionButton
        icon={faObjectGroup}
        text="قــــائـــمة عــائلات البـــــضاعـــة"
        onClick={() => onNavigate("/famille-liste", { wcli: varGlo })}
        arabic
      />
      <ActionButton
        icon={faListOl}
        text="قـــــــائـــــــــمة الطلبيـــات"
        onClick={() => onNavigate("/liste-commandes-rep")}
        arabic
      />
      <ActionButton
        icon={faPersonCirclePlus}
        text="اظافة حريف"
        onClick={() => onNavigate("/ajout-client", { societe })}
        arabic
      />
      <ActionButton
        icon={faMessage}
        text="مراسلة"
        onClick={() => onNavigate("/liste-messages")}
        arabic
      />
    </div>
  </div>
);

// Component for English language view
const EnglishView = ({ onNavigate }) => (
  <div className="view-container">
    <div className="button-grid">
      <ActionButton
        icon={faLayerGroup}
        text="Product Categorie"
        onClick={() => onNavigate("/marque-liste")}
      />
      <ActionButton
        icon={faObjectGroup}
        text="Product Family"
        onClick={() => onNavigate("/famille-liste")}
      />
      <ActionButton
        icon={faListOl}
        text="My Orders"
        onClick={() => onNavigate("/liste-commandes-rep")}
      />
      <ActionButton
        icon={faPersonCirclePlus}
        text="Client Creation"
        onClick={() => onNavigate("/ajout-client")}
      />
      <ActionButton
        icon={faMessage}
        text="Contact"
        onClick={() => onNavigate("/liste-commandes-rep")}
      />
    </div>
  </div>
);

// Reusable button component
const ActionButton = ({ icon, text, onClick, arabic = false }) => (
  <button
    className={`action-button-repres${arabic ? "arabic" : ""}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon} size="2x" className="button-icon" />
    <span className="button-text">{text}</span>
  </button>
);

// CSS Styles (should be in a separate file)

// Add styles to the document

export default DemRepres;
